const f = {
  color: {
    grey: {
      default: {
        bg: "#556575ff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#556575ff",
        border: "#dfe6ebff"
      },
      tone: {
        bg: "#f9fafaff",
        text: "#556575ff",
        border: "#dfe6ebff"
      }
    },
    red: {
      default: {
        bg: "#b83525ff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#b83525ff",
        border: "#e54a32ff"
      },
      tone: {
        bg: "#fff0e8ff",
        text: "#b83525ff",
        border: "#ffbcadff"
      }
    },
    blue: {
      default: {
        bg: "#304ddbff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#304ddbff",
        border: "#4176faff"
      },
      tone: {
        bg: "#ebf5ffff",
        text: "#304ddbff",
        border: "#9ecbffff"
      }
    },
    green: {
      default: {
        bg: "#2d8556ff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#28704cff",
        border: "#47c47dff"
      },
      tone: {
        bg: "#f2fff0ff",
        text: "#28704cff",
        border: "#b9edbdff"
      }
    },
    yellow: {
      default: {
        bg: "#a35214ff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#a35214ff",
        border: "#fabf5aff"
      },
      tone: {
        bg: "#fff6e5ff",
        text: "#a35214ff",
        border: "#ffdd99ff"
      }
    },
    purple: {
      default: {
        bg: "#774ba3ff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#5d407aff",
        border: "#9163bfff"
      },
      tone: {
        bg: "#f9f2ffff",
        text: "#5d407aff",
        border: "#d7baf5ff"
      }
    },
    lilac: {
      default: {
        bg: "#9747fcff",
        text: "#fff"
      },
      inverted: {
        bg: "#ffffffff",
        text: "#7935cfff",
        border: "#7935cfff"
      },
      tone: {
        bg: "#fcf9ffff",
        text: "#7935cfff",
        border: "#cda9ffff"
      }
    },
    ai: {
      text: "linear-gradient(121.57deg, #2835db 18.41%, #ad4afb 74.17%)",
      bg: "#c285ffff",
      gradient: "linear-gradient(238.06deg, #ffa977 5.4%, #ff85da 33.68%, #7d77ff 67.8%,#68ece6 95.59%)"
    }
  }
};
export {
  f as badge
};
